import { BaseIconProps } from "../../types/styles";

const AxialViewIcon = ({
    id,
    className,
    size = 32,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--color-white)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-axial"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                d="M29.6667 11.6665L16.3333 2.99988L3 11.6665L16.3333 20.9999L29.6667 11.6665Z"
                fill={color}
            />
            <path
                d="M3 11.6665V20.9999L16.3333 29.6665L29.6667 20.9999V11.6665L16.3333 2.99988L3 11.6665ZM29.6667 11.6665L16.3333 20.9999M16.3333 29.6665L16.3333 20.9999M3 11.6665L16.3333 20.9999"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AxialViewIcon;
